import { Txt } from 'components/Txt';
import { FontFamilyMonoSemibold } from 'lib/theme';
import { chunk } from 'lodash';
import React from 'react';
import { View } from 'react-native';
import { MonthEnum, Months } from 'types/types';

interface Props {
  selectedMonths: MonthEnum[];
}

export const DateSelectedMonthsIndicator: React.FC<Props> = ({
  selectedMonths,
}) => {
  return (
    <View style={{ rowGap: 1, width: 60 }}>
      {chunk(Months, 3).map((quarter) => (
        <View
          key={quarter.map((q) => q.number).join('-')}
          style={{
            flexDirection: 'row',
            flex: 1,
            columnGap: 2,
          }}
        >
          {quarter.map((month) => (
            <Txt
              key={month.number}
              style={{
                fontFamily: FontFamilyMonoSemibold,
                backgroundColor: '#000',
                color: '#fff',
                flex: 1,
                textAlign: 'center',
                paddingHorizontal: 2,
                paddingVertical: 0,
                borderRadius: 4,
                opacity: selectedMonths.includes(month.name) ? 1 : 0.2,
              }}
              size="xxxsmall"
            >
              {month.number}
            </Txt>
          ))}
        </View>
      ))}
    </View>
  );
};
